// extracted by mini-css-extract-plugin
module.exports = {"tx_green":"Form_tx_green__NG4je","form_di":"Form_form_di__3Wk_2","errors":"Form_errors__32NOl"};